import { useEffect, useRef, useState } from "react";

/* ===== BASE WIDTH ===== */
const BASE_W = 1560;

/* ===== IMAGES ===== */
const SHIRTS = [
  "/Rectangle391.png",
  "/Rectangle392.png",
  "/Rectangle393.png",
  "/Rectangle394.png",
  "/Rectangle395.png",
  "/Rectangle396.png",
  "/Rectangle397.png",
  "/Rectangle398.png",
  "/Rectangle399.png",
  "/Rectangle400.png",
  "/Rectangle401.png",
  "/Rectangle402.png",
  "/Rectangle403.png",
  "/Rectangle391.png",
  "/Rectangle392.png",
  "/Rectangle393.png",
  "/Rectangle394.png",
  "/Rectangle395.png",
  "/Rectangle396.png",
  "/Rectangle397.png",
  "/Rectangle398.png",
  "/Rectangle399.png",
  "/Rectangle400.png",
  "/Rectangle401.png",
  "/Rectangle402.png",
  "/Rectangle403.png",
];

export default function CreateWorthWearing() {
  const ref = useRef(null);

  const [scrollRatio, setScrollRatio] = useState(0);
  const [vw, setVw] = useState(
    typeof window !== "undefined" ? window.innerWidth : BASE_W
  );

  useEffect(() => {
    const onResize = () => setVw(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const scrollableHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      if (scrollableHeight <= 0) return;

      setScrollRatio(scrollTop / scrollableHeight);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isMobile = vw < 768;
  const ORBIT_IMAGES = isMobile ? SHIRTS.slice(0, 14) : SHIRTS;

  const containerW = Math.min(vw, BASE_W);
  const containerH = isMobile ? 520 : 720;

  const radius = isMobile ? 180 : 540;
  const startAngle = 0;
  const endAngle = Math.PI * 2;

  const centerX = containerW / 2;
  const centerY = isMobile ? 240 : 630;

  const MAX_ROTATIONS = isMobile ? 1.3 : 1;
  const rotation = scrollRatio * MAX_ROTATIONS * Math.PI * 2;

  return (
    <section
      ref={ref}
      className="relative w-full flex justify-center bg-white"
      style={{
        height: containerH,
        paddingTop: "4vh",
        paddingBottom: "4vh",
        overflow: "hidden",
      }}
    >
      <div
        className="relative"
        style={{
          width: containerW,
          height: containerH,
        }}
      >
        {/* ===== ORBIT ===== */}
        {ORBIT_IMAGES.map((img, i) => {
          const t = i / (ORBIT_IMAGES.length - 1);

          const theta =
            startAngle +
            (endAngle - startAngle) * t +
            rotation;

          const x = centerX + radius * Math.cos(theta);
          const y = centerY + radius * Math.sin(theta);

          return (
            <img
              key={img}
              src={img}
              alt=""
              style={{
                position: "absolute",
                width: isMobile ? 54 : 104,
                height: isMobile ? 54 : 104,
                left: x,
                top: y,
                transform: "translate(-50%, -50%)",
                borderRadius: 18,
                background: "#fff",
                boxShadow: "0 10px 28px rgba(0,0,0,0.12)",
                transition:
                  "left 0.5s cubic-bezier(0.22,1,0.36,1), top 0.5s cubic-bezier(0.22,1,0.36,1)",
              }}
            />
          );
        })}

        {/* ===== CENTER CONTENT ===== */}
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: isMobile ? "45%" : "58%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            maxWidth: isMobile ? 300 : 760,
            fontFamily: "'Coldiac Free', serif",
          }}
        >
          <h1
            style={{
              fontFamily: "'PP Neue Montreal', sans-serif",
              fontWeight: 400,
              fontSize: "clamp(36px, 4.5vw, 60px)",
              lineHeight: "1.18",
              letterSpacing: "0.05em",
              color: "#0b0b0b",
            }}
          >
            <span style={{ display: "block" }}>Let&apos;s Create</span>
            <span style={{ display: "block" }}> Something Worth</span>
            <span style={{ display: "block" }}>Wearing</span>
          </h1>

          <div
            style={{
              display: "flex",
              gap: 14,
              justifyContent: "center",
              flexWrap: "wrap",
              fontFamily: "Montserrat, sans-serif",
              marginTop: isMobile ? 1 : 40,
            }}
          >
            {/* Animated WhatsApp Button */}
            <button
  onClick={() =>
    window.open(
      "https://wa.me/918080907304?text=Hi%20I%20have%20a%20query",
      "_blank"
    )
  }
  className="
    z-30 relative overflow-hidden
    bg-[#FE7814]
    after:-z-20 after:absolute after:h-1 after:w-1
    after:bg-orange-700 after:left-5 after:bottom-0
    after:translate-y-full after:rounded-md
    after:hover:scale-[300]
    after:hover:transition-all
    after:hover:duration-700
    after:transition-all after:duration-700
    transition-all duration-700
    hover:shadow-lg
  "
  style={{
    width: isMobile ? 140 : 180,
    height: isMobile ? 38 : 48,
    border: "1px solid #000",
    fontSize: isMobile ? 15 : 17,
    cursor: "pointer",
    fontFamily: "Montserrat, sans-serif",
  }}
>
  Talk To Us
</button>


          </div>
        </div>
      </div>
    </section>
  );
}
